import apiClient from '../api';
import type { SkillGainsData } from '@/components/common/SkillRadarChart';

export interface PublicVerificationData {
    id: string;
    certificate_number: string;
    student_name: string;
    enrollment_number: string;
    cohort_name: string;
    school_name?: string | null;
    completion_date: string;
    issued_at: string;
    certificate_url: string;
    certificate_image_url?: string | null;
    profile_picture: string | null;
    project: {
        project_title: string | null;
        project_description: string | null;
        school_name?: string | null;
        demo_presentation_path: string | null;
        demo_presentation_name: string | null;
        project_screenshot_path?: string | null;
        project_screenshot_name?: string | null;
        problem_area?: string | null;
        problem_area_generated_at?: string | null;
        linkedin_post_content?: string | null;
    };
    verified: boolean;
    skill_gains?: SkillGainsData | null;
}

export const verificationService = {
    getVerification: async (id: string): Promise<PublicVerificationData> => {
        const res = await apiClient.get(`/admin/students/public/verify/${id}`);
        return res.data.data;
    },
    getCertificateLinkedInPost: async (id: string): Promise<{ linkedin_post_content: string; is_cached: boolean }> => {
        const res = await apiClient.post(`/admin/students/public/certificate/${id}/linkedin-post`);
        return res.data.data;
    }
};

export default verificationService;
